export const AuthUrl = {
  // register user
  RegisterUser: '/PreReserve/UserManagementCommand/SetSSOUser',
  ChangePassword: '/PreReserve/UserManagementCommand/SetSSOUserPassword',
  // Otp
  CreateOtp: '/PreReserve/OTPCommand/CreateOTP',
  ResetPassword: '/PreReserve/UserManagementCommand/ResetSSOUserPassword',
}
